import React, { Component } from 'react'
import classes from './SetupLevelGroup.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupLevelGroup/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupLevelGroup extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    addAno: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      level_group_name: {
        label: this.props.translate('levelGroupName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('levelGroupName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalType')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      },
      is_vfr: {
        label: this.props.translate('is_vfr'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      level_group_id: {
        label: this.props.translate('levelGroupName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroupName'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('levelGroupName')
            }
          ]
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('active'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('active') }
          ]
        }
      }
    },
    updateProps: {
      companyOptions: this.props.companyOptions,
      appraisalTypeOptions: this.props.appraisalTypeOptions,
      filterLevelGroup: this.props.filterLevelGroup,
      filterActive: this.props.filterActive,
      selectedRecord: this.props.selectedRecord
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('levelGroup'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('levelGroup'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.level_group_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('levelGroup'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.level_group_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'level_group_name', title: this.props.translate('levelGroupName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    },
    {
      field: 'is_vfr',
      title: this.props.translate('is_vfr'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_vfr} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchLevelGroup()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    const updateOptions = (stateId, propsId, attr, withCode) => {
      const inputGroups = state.inputGroups
      const targetLevelGroupItem = inputGroups[stateId]
      let [attrId, attrCode, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelGroupItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder,
            null,
            null,
            withCode ? attrCode : null
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr
      let value = state.filterControls[stateId].value
      if (props[propsId].length === 0) {
        value = 'No Data'
      }
      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.appraisalTypeOptions !== updateProps.appraisalTypeOptions) {
      updateOptions('appraisal_type_id', 'appraisalTypeOptions', [
        'value_list_id',
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' },
        'Select Appraisal'
      ])
    }
    if (props.filterLevelGroup !== updateProps.filterLevelGroup) {
      updateFilter('level_group_id', 'filterLevelGroup', ['level_group_id', 'level_group_name'])
    }
    if (props.filterActive !== updateProps.filterActive) {
      updateFilter('is_active', 'filterActive', ['active_id', 'active_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let { inputGroups } = state
      let newStructureData = Object.entries(inputGroups).reduce((levelGroups, structure) => {
        let [levelGroupKey, levelGroupAttrs] = structure
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!levelGroupAttrs.validation || !levelGroupAttrs.validation.required) {
          valid = true
        }
        if (levelGroupAttrs.elementType === 'checkbox') {
          value = false
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[levelGroupKey]) {
          value = props.selectedRecord[levelGroupKey]
          let { isValid, error } = checkValidity(
            value,
            levelGroupAttrs.validation,
            levelGroupAttrs.label
          )
          if (levelGroupAttrs.elementType === 'newselect') {
            value =
              state.inputGroups[levelGroupKey].elementConfig.options.find(
                res => res.value === value
              ) || value
          }
          if (levelGroupAttrs.elementType === 'newmultiSelect') {
            value = value.map(dat => {
              return inputGroups[levelGroupKey].elementConfig.options.find(
                res => res.value === dat.role_id
              )
            })
          }
          if (levelGroupAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newStructureAttrs = {
          ...levelGroupAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }
        return updateObject(levelGroups, { [levelGroupKey]: { ...newStructureAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newStructureData,
        updateProps: { ...updateProps, selectedRecord: props.selectedRecord }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchLevelGroup(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchLevelGroup(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})

    this.setState({
      inputGroups: newFormData
    })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchLevelGroupById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }
  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }
  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        modalOpen: false
      })
    }
  }

  levelGroupSubmitHandler = type => {
    let levelGroupData = Object.entries(this.state.inputGroups).reduce(
      (levelGroupData, levelGroupEntry) => {
        let [levelGroupKey, levelGroupAttrs] = levelGroupEntry
        let value = ''
        if (levelGroupAttrs.elementType === 'newselect') {
          value = levelGroupAttrs.value?.value
        } else if (levelGroupAttrs.elementType === 'newmultiSelect') {
          value = levelGroupAttrs.value.map(res => {
            return { role_id: res.value }
          })
        } else {
          value = levelGroupAttrs.value
        }
        if (levelGroupKey === 'value_list_id') {
          levelGroupKey = 'appraisal_type_id'
        }
        return { ...levelGroupData, [levelGroupKey]: value }
      },
      {}
    )

    if (this.state.action === 'add') {
      this.props.createLevelGroup(
        { ...levelGroupData },
        getPageStatus(this.props.pagination, false)
      )
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateLevelGroup(
        this.state.actionRecordId,
        { ...levelGroupData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (levelGroupKey, event) => {
    const inputGroup = this.state.inputGroups

    const levelGroupItem = inputGroup[levelGroupKey]

    let inputValue = ''

    switch (levelGroupItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !levelGroupItem.value
        break
      case 'newmultiSelect':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(
      inputValue,
      levelGroupItem.validation,
      levelGroupItem.label
    )

    let updatedStructureItem = {
      ...levelGroupItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [levelGroupKey]: updatedStructureItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    let newStructure = inputGroup

    newStructure = updateObject(newStructure, { [levelGroupKey]: updatedStructureItem })

    this.setState({
      inputGroups: newStructure,
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteLevelGroup(recordId, getPageStatus(this.props.pagination, true))
    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchFilter({ company_id: filterValue?.value })
    }
    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    this.props.fetchLevelGroup(this.state.filter)
    this.closeFilterModal()
  }

  render() {
    let form = <Spinner />
    if (this.state.action === 'edit') {
      if (this.props.selectedRecord && !this.props.loading) {
        form = (
          <Form
            form={this.state.inputGroups}
            inputChanged={this.inputChangeHandler}
            formValid={this.state.formIsValid}
          />
        )
      }
    } else if (!this.props.loading) {
      form = (
        <Form
          form={this.state.inputGroups}
          inputChanged={this.inputChangeHandler}
          formValid={this.state.formIsValid}
        />
      )
    }

    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.levelGroupSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.levelGroupSubmitHandler('save')}
        another={() => this.levelGroupSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('levelGroup')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{form}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('levelGroup')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.levelGroup.pagination,
    data: state.levelGroup.records,
    loading: state.levelGroup.loading,
    filterLoading: state.levelGroup.filterLoading,
    success: state.levelGroup.success,
    selectedRecord: state.levelGroup.selectedRecord,
    companyOptions: state.levelGroup.company,
    appraisalTypeOptions: state.levelGroup.appraisalType,
    filterLevelGroup: state.levelGroup.filterLevelGroup,
    filterActive: state.levelGroup.filterActive,
    loadingQueue: state.levelGroup.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLevelGroup: filterOptions => dispatch(actions.fetchLevelGroup(filterOptions)),
    fetchLevelGroupById: recordId => dispatch(actions.fetchLevelGroupById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedLevelGroupRecord()),
    createLevelGroup: (recordData, page) => dispatch(actions.createLevelGroup(recordData, page)),
    updateLevelGroup: (recordId, recordData, page) =>
      dispatch(actions.updateLevelGroup(recordId, recordData, page)),
    deleteLevelGroup: (recordId, page) => dispatch(actions.deleteLevelGroup(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchLevelGroupFilterActive(filter))
      dispatch(actions.fetchLevelGroupFilterLevelGroup(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupLevelGroup))
